const routes = [
    {
        path: "/announcements",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission:'announcement_index'
        },
        component_full_path: 'announcement/pages/Index'
    }
];

export default routes;
